import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";

import ListPlaylists from './ListPlaylists';
import ListUsers from './ListUsers';
import ModalChat from './ModalChat';
import DividingLine from '../left-bar/DividingLine';

import ButtonStart from './ButtonStart';
import ButtonEnd from './ButtonEnd';
import ListSessions from './ListSessions';

import './LeftBlock.css';
import './PartyMode.css';

import usePartyMode from './hooks/usePartyMode';
import { setEnablePM } from "./redux/actions/index";

function ConnectedLeftBlock({ className, style, height, visible, active }) {

  const dispatch = useDispatch();
  const { closeRoom, leaveRoom, getRoomName, getRoomType } = usePartyMode();
  useEffect(() => {
    if (visible) {
      dispatch(setEnablePM(true));
    }
  }, [dispatch, visible])

  return (
    <div id={`left-block-pm`} className={className} style={style}>
      { (active) ? (
        <>
          <ButtonEnd closeRoom={closeRoom} leaveRoom={leaveRoom} roomName={getRoomName()} />
          <div className={`flexColumn`} style={{ height, overflow: `auto`, overflowX: 'hidden', gap: 16 }}>
            <ListPlaylists />
            <DividingLine />
            <ListUsers show={true} roomType={getRoomType()} />
            <DividingLine />
            <ModalChat />
          </div>
        </>
      ) : (
        <div className={`flexColumn`} style={{ height, overflow: `auto`, padding: '11px 8px 0px 8px', overflowX: 'hidden', gap: 16 }}>
          <ButtonStart />
          <ListSessions height={height} />
        </div>
      )}
    </div>
  )
}

ConnectedLeftBlock.propTypes = {
  visible: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

const LeftBlock = connect(
  state => ({
    active: state.inRoomPM
  })
)(ConnectedLeftBlock);

export default LeftBlock;
